export const FETCH_STATES_REQUEST = "FETCH_STATES_REQUEST";
export const CHANGE_STATE_STATUS_REQUEST = "CHANGE_STATE_STATUS_REQUEST";
export const UPDATE_STATE_REQUEST = "UPDATE_STATE_REQUEST";
export const CREATE_STATE_REQUEST = "CREATE_STATE_REQUEST";
export const CHANGE_STATE_WEIGHT_REQUEST = "CHANGE_STATE_WEIGHT_REQUEST";
